import React from 'react';
import { UsersRound } from 'lucide-react';
import { formatCurrency, formatPercent, formatDuration, formatDate } from '../../../../utils/formatters';
import { Card, CardHeader, CardTitle, CardContent } from '../../../../components/ui/Card';
import DefinitionItem from './DefinitionItem';

export default function ClubDealOverview({ transaction }) {
  const investors = transaction.participants?.filter(p => p.role === 'Investisseur' || p.role === 'Prêteur') || [];
  const totalEngaged = investors.reduce((sum, p) => sum + (p.committedAmount || 0), 0);
  const engagementRate = Math.min((totalEngaged / (transaction.targetAmount || 1)) * 100, 100);

  return (
    <Card className="shadow-hp-sm">
      <CardHeader className="flex flex-row items-center gap-3 border-b border-[var(--hp-color-border-muted)] px-5 py-4">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-surface-muted text-primary">
          <UsersRound className="h-4.5 w-4.5" />
        </div>
        <div>
          <CardTitle className="text-base font-semibold text-primary">Structure du club deal</CardTitle>
          <p className="mt-0.5 text-sm text-subtle">Paramètres de souscription et modalités de l'investissement.</p>
        </div>
      </CardHeader>

      <CardContent className="p-5">
        <dl className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-3">
          <DefinitionItem
            label="Montant souscrit"
            value={formatCurrency(totalEngaged, transaction.currency)}
            emphasis
          />

          <DefinitionItem
            label="Ticket minimum"
            value={transaction.minimumTicket ? formatCurrency(transaction.minimumTicket, transaction.currency) : "Non renseigné"}
          />

          <DefinitionItem
            label="Nombre d'investisseurs"
            value={investors.length.toString()}
          />

          <DefinitionItem
            label="Durée d'investissement"
            value={formatDuration(transaction.durationMonths)}
          />

          <DefinitionItem
            label="Rendement cible"
            value={formatPercent(transaction.yieldRate)}
          />

          <DefinitionItem
            label="Date limite de souscription"
            value={formatDate(transaction.expectedCloseAt)}
          />
        </dl>

        <div className="mt-8">
          <div className="flex items-center justify-between text-xs font-medium mb-2">
            <span className="text-subtle">Progression de la collecte</span>
            <span className="text-primary">{engagementRate.toFixed(1)}%</span>
          </div>
          <div className="h-2 w-full overflow-hidden rounded-full bg-surface-muted">
            <div
              className="h-full rounded-full bg-primary transition-all duration-500"
              style={{ width: `${engagementRate}%` }}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
